<div class="container-fluid overflow-hidden" style="display:none;">
  <div class="row mt-5">
    <div class="col-lg-8 text-center mx-auto">
      <div class="card">
        <div class="card-body">
          <div
            class="page-title-box d-sm-flex align-items-center justify-content-center"
          >
            <img
              src="../../../../assets/images/Ripple Safe Home Logo.png"
              alt="Ripple Logo"
              class="ripple-logo"
            />
          </div>
          <h3 class="mt-0">Ripple Safe Home Device Registration</h3>
          <ng-stepper
            #cdkStepper
            [linear]="true"
            class="wizard"
            (selectionChange)="onStepChange($event)"
          >
            <cdk-step [optional]="false" [ariaDisabled]="true">
              <ng-template cdkStepLabel>
                <span>New User </span>
                <!--   <span>New User {{breadCrumbItems|json}}</span> -->
              </ng-template>
              @if (cdkStepper.selectedIndex === 0) {
                <div class="row">
                  <form [formGroup]="newUserForm">
                    <div class="row mb-3">
                      <div class="col-md-6  ">
                        <label for="b" class="form-label label-center"
                          >Mobile <span class="required">*</span></label
                        >
                          <div class="input-group mobile-input-group">
                          <ng-select
                            [items]="countryCodes"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="countrycode"
                            placeholder="Select country"
                            class="ng-select-custom-size"
                            appendTo="body"
                            (change)="PrimaryvaliadationMobile($event)"
                          >
                            <ng-template ng-label-tmp let-item="item">
                              <span
                                >{{ item.shortName }} ({{ item.code }})</span
                              >
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                              <span>{{ item.name }} ({{ item.code }})</span>
                            </ng-template>
                          </ng-select>

                          <input
                            type="text"
                            class="form-control phone-number-input"
                            id="mobileNo"
                            formControlName="mobileNo"
                            placeholder="Enter mobile number"
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            [disabled]="isDeviceIdValid"
                            (click)="isDeviceIdCheckNewUser()"
                          >
                            Continue
                          </button>
                        </div>
                        <div
                          *ngIf="
                            IsnewUsersubmitted &&
                            individualControls['countrycode'].errors
                          "
                          class="invalid-feedback label-center"
                        >
                          <div
                            *ngIf="
                              individualControls['countrycode'].errors[
                                'required'
                              ]
                            "
                          >
                            {{
                              prifileValidations.consumersPage.countryCode
                                .countryCode_required
                            }}
                          </div>
                        </div>

                        @if (
                          IsnewUsersubmitted &&
                          individualControls["mobileNo"].errors
                        ) {
                          <div
                            class="invalid-feedback label-center d-flex flex-column"
                          >
                            @if (
                              individualControls["mobileNo"].errors["required"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.consumersPage.mobile
                                    .mobile_required_validations
                                }}
                              </div>
                            }

                            @if (
                              individualControls["mobileNo"].errors["pattern"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.consumersPage.mobile
                                    .mobile_format
                                }}
                              </div>
                            }
                            @if (
                              individualControls["mobileNo"].errors["maxlength"]
                            ) {
                              <div>{{ valiadationMessage }}</div>
                            }
                            @if (
                              individualControls["mobileNo"].errors["minlength"]
                            ) {
                              <div>{{ valiadationMessage }}</div>
                            }
                          </div>
                        }
                      </div>

                      <div class="col-md-6  " *ngIf="isdeviceId">
                        <label for="deviceId" class="form-label label-center">
                          Device ID <span class="required">*</span>
                        </label>
                        <ng-select
                          [items]="deviceIdList"
                          bindLabel="device_id"
                          bindValue="device_id"
                          formControlName="deviceId"
                          placeholder="Select country"
                          appendTo="body"
                          (change)="deviceIdchangesNewUser($event)"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            <span>{{ item.device_id }}</span>
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                            <span>{{ item.device_id }}</span>
                          </ng-template>
                        </ng-select>
                        @if (
                          (IsnewUsersubmitted ||
                            individualControls["deviceId"]?.touched) &&
                          individualControls["deviceId"]?.errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["deviceId"]?.errors?.[
                                "required"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .deviceId
                                }}
                              </div>
                            }

                            <!--  @if(individualControls['deviceId']?.errors?.['pattern']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId_pattern
                                                        }}
                                                    </div>
                                                    }

                                                    @if(individualControls['deviceId']?.errors?.['maxlength'] ||
                                                    individualControls['deviceId']?.errors?.['minlength']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.max }}</div>
                                                    } -->
                          </div>
                        }
                      </div>

                      <!--   <div class="col-md-6 " *ngIf="isDeviceIdValid">
                                            <div class="">
                                                <label for="deviceId" class="form-label label-center">
                                                    Device ID <span class="required">*</span>
                                                </label>

                                                <div class="input-group">
                                                    <input type="text" formControlName="deviceId" class="form-control"
                                                        id="deviceId" placeholder="Enter Device ID" />

                                                      <button type="button" class="btn btn-primary" [disabled]="isDeviceIdValid"
                                                        (click)="isDeviceIdCheckNewUser()">
                                                        Continue
                                                    </button>
                                                </div>

                                                @if((IsnewUsersubmitted || individualControls['deviceId']?.touched) &&
                                                individualControls['deviceId']?.errors) {
                                                <div class="invalid-feedback d-block label-center">

                                                    @if(individualControls['deviceId']?.errors?.['required']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId }}</div>
                                                    }

                                                    @if(individualControls['deviceId']?.errors?.['pattern']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId_pattern
                                                        }}
                                                    </div>
                                                    }

                                                    @if(individualControls['deviceId']?.errors?.['maxlength'] ||
                                                    individualControls['deviceId']?.errors?.['minlength']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.max }}</div>
                                                    }

                                                </div>
                                                }
                                            </div>
                                        </div> -->
                    </div>

                    <div class="row mb-3" *ngIf="isDeviceIdValid">
                      <div class="col-md-6  ">
                        <label for="name" class="form-label label-center"
                          >Name <span class="required">*</span></label
                        >
                        <input
                          type="text"
                          formControlName="name"
                          class="form-control"
                          id="name"
                          placeholder="Enter your name"
                        />
                        @if (
                          IsnewUsersubmitted &&
                          individualControls["name"].errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["name"].errors["required"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage.name
                                }}
                              </div>
                            }

                            @if (
                              individualControls["name"].errors["minlength"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.ProfilePage.firstName
                                    .min_required_Validations
                                }}
                              </div>
                            }
                            @if (
                              individualControls["name"].errors["maxlength"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.ProfilePage.firstName
                                    .min_required_Validations
                                }}
                              </div>
                            }
                            @if (individualControls["name"].errors["pattern"]) {
                              <div>
                                {{
                                  prifileValidations.ProfilePage.firstName
                                    .allow_spaces
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="col-md-6  ">
                        <label for="email" class="form-label label-center"
                          >Email
                        </label>
                        <input
                          type="email"
                          formControlName="email"
                          class="form-control"
                          id="email"
                          placeholder="Enter your email"
                        />
                        @if (
                          IsnewUsersubmitted &&
                          individualControls["email"].errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["email"].errors["required"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.ProfilePage
                                    .emmail_validation
                                    .email_required_validations
                                }}
                              </div>
                            }
                            @if (
                              individualControls["email"].errors["pattern"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.ProfilePage
                                    .emmail_validation.email_pattern
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row mb-3" *ngIf="isDeviceIdValid">
                      <div class="col-md-6  ">
                        <label for="flatNo" class="form-label label-center"
                          >Flat No / House No<span class="required">*</span></label
                        >
                        <input
                          type="text"
                          formControlName="flatNo"
                          class="form-control"
                          id="flatNo"
                          placeholder="Enter your FlatNo / HouseNo"
                        />
                        @if (
                          (IsnewUsersubmitted ||
                            individualControls["flatNo"]?.touched) &&
                          individualControls["flatNo"]?.errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["flatNo"]?.errors?.["required"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage.falt
                                }}
                              </div>
                            }

                            @if (
                              individualControls["flatNo"]?.errors?.["pattern"]
                            ) {
                              <div>
                                {{ prifileValidations.residentialUnit.patten }}
                              </div>
                            }

                            @if (
                              individualControls["flatNo"]?.errors?.[
                                "maxlength"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.residentialUnit
                                    .maxlengthFlat
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="col-md-6  ">
                        <label for="floor" class="form-label label-center"
                          >Floor</label
                        >
                        <input
                          type="text"
                          formControlName="floor"
                          class="form-control"
                          id="floor"
                          placeholder="Ignore if not applicable"
                          (blur)="individualControls['floor']?.markAsTouched()"
                        />
                        @if (
                          (IsnewUsersubmitted ||
                            individualControls["floor"]?.touched ||
                            individualControls["floor"]?.dirty) &&
                          individualControls["floor"]?.errors
                        ) {
                          <div class="invalid-feedback label-center mb-1">
                            @if (
                              individualControls["floor"]?.errors?.["pattern"]
                            ) {
                              <div>
                                {{ prifileValidations.residentialUnit.patten }}
                              </div>
                            }

                            @if (
                              individualControls["floor"]?.errors?.["maxlength"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.residentialUnit
                                    .maxlengthfloor
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row mb-3" *ngIf="isDeviceIdValid">
                      <div class="col-md-6  ">
                        <label for="block" class="form-label label-center"
                          >Block</label
                        >
                        <input
                          type="text"
                          formControlName="block"
                          class="form-control"
                          id="block"
                          placeholder="Ignore if not applicable"
                          (blur)="individualControls['block']?.markAsTouched()"
                        />
                        @if (
                          (IsnewUsersubmitted ||
                            individualControls["block"]?.touched ||
                            individualControls["block"]?.dirty) &&
                          individualControls["block"]?.errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["block"]?.errors?.["pattern"]
                            ) {
                              <div>
                                {{ prifileValidations.residentialUnit.patten }}
                              </div>
                            }

                            @if (
                              individualControls["block"]?.errors?.["maxlength"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.residentialUnit
                                    .maxlengthblock
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="col-md-6  ">
                        <label for="tower" class="form-label label-center"
                          >Tower</label
                        >
                        <input
                          type="text"
                          formControlName="tower"
                          class="form-control"
                          id="tower"
                          placeholder="Ignore if not applicable"
                          (blur)="individualControls['tower']?.markAsTouched()"
                        />
                        @if (
                          (IsnewUsersubmitted ||
                            individualControls["tower"]?.touched ||
                            individualControls["tower"]?.dirty) &&
                          individualControls["tower"]?.errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["tower"]?.errors?.["pattern"]
                            ) {
                              <div>
                                {{ prifileValidations.residentialUnit.patten }}
                              </div>
                            }

                            @if (
                              individualControls["tower"]?.errors?.["maxlength"]
                            ) {
                              <div>
                                {{
                                  prifileValidations.residentialUnit
                                    .maxlengthtower
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row mb-3" *ngIf="isDeviceIdValid">
                      <div class="col-md-6  ">
                        <label for="name" class="form-label label-center"
                          >Address <span class="required">*</span></label
                        >
                        <input
                          type="text"
                          formControlName="deviceAddress"
                          class="form-control"
                          id="name"
                          placeholder="Enter your address"
                        />
                        @if (
                          IsnewUsersubmitted &&
                          individualControls["deviceAddress"].errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["deviceAddress"].errors[
                                "required"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .address
                                }}
                              </div>
                            }
                            @if (
                              individualControls["deviceAddress"].errors[
                                "pattern"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .addres_pattren
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="col-md-6  ">
                        <label for="email" class="form-label label-center"
                          >Installed Location
                          <span class="required">*</span></label
                        >
                        <input
                          type="email"
                          formControlName="installedLocation"
                          class="form-control"
                          id="email"
                          placeholder="Enter your installed location"
                        />
                        @if (
                          IsnewUsersubmitted &&
                          individualControls["installedLocation"].errors
                        ) {
                          <div class="invalid-feedback label-center">
                            @if (
                              individualControls["installedLocation"].errors[
                                "required"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .location
                                }}
                              </div>
                            }
                            @if (
                              individualControls["installedLocation"].errors[
                                "pattern"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .Installed_pattren
                                }}
                              </div>
                            }
                            @if (
                              individualControls["installedLocation"].errors[
                                "maxlength"
                              ]
                            ) {
                              <div>
                                {{
                                  prifileValidations.gasLeakDetectoresePage
                                    .maxInstalledlocationCharlength
                                }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </form>
                  <ul
                    class="list-inline wizard d-flex justify-content-end mt-3"
                    *ngIf="isDeviceIdValid"
                  >
                    <!--  <li class="next list-inline-item" ><button class="btn btn-primary"
                                                    (click)="newUserCreate()">Create Device</button>
                                            </li> -->
                    <li class="next list-inline-item">
                      <button
                        class="btn btn-primary"
                        (click)="MobileNoChekNewUser()"
                      >
                        Create Device
                      </button>
                    </li>
                  </ul>
                </div>
              }
            </cdk-step>
            <cdk-step [optional]="false" [ariaDisabled]="true">
              <ng-template cdkStepLabel>
                <span>Existing User </span>
              </ng-template>
              @if (cdkStepper.selectedIndex === 1) {
                <section class="">
                  <form [formGroup]="exstingUserForm">
                    <div class="row mb-3">
                      <div class="col-md-6 ">
                        <div class="">
                          <label for="b" class="form-label label-center"
                            >Mobile <span class="required">*</span></label
                          >
                          <div class="input-group mobile-input-group">
                            <ng-select
                              [items]="countryCodes"
                              bindLabel="name"
                              bindValue="id"
                              formControlName="countrycode"
                              placeholder="Select country"
                              class="ng-select-custom-size"
                              appendTo="body"
                              (change)="exstingUseronMobile($event)"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                <span
                                  >{{ item.shortName }} ({{ item.code }})</span
                                >
                              </ng-template>

                              <ng-template ng-option-tmp let-item="item">
                                <span>{{ item.name }} ({{ item.code }})</span>
                              </ng-template>
                            </ng-select>

                            <input
                              type="text"
                              class="form-control phone-number-input"
                              id="mobileNo"
                              formControlName="mobileNo"
                              placeholder="Enter mobile number"
                            />

                            <button
                              type="button"
                              class="btn btn-primary"
                              [disabled]="isdeviceIdExstingUserValid"
                              (click)="isDeviceIdCheckExstingUser()"
                            >
                              Continue
                            </button>
                          </div>
                          <div
                            *ngIf="
                              IsExstingUsersubmitted &&
                              exstingUserControls['countrycode'].errors
                            "
                            class="invalid-feedback label-center"
                          >
                            <div
                              *ngIf="
                                exstingUserControls['countrycode'].errors[
                                  'required'
                                ]
                              "
                            >
                              {{
                                prifileValidations.consumersPage.countryCode
                                  .countryCode_required
                              }}
                            </div>
                          </div>
                          <!-- Validation Feedback -->
                          @if (
                            IsExstingUsersubmitted &&
                            exstingUserControls["mobileNo"].errors
                          ) {
                            <div class="invalid-feedback label-center">
                              @if (
                                exstingUserControls["mobileNo"].errors[
                                  "required"
                                ]
                              ) {
                                <div>
                                  {{
                                    prifileValidations.consumersPage.mobile
                                      .mobile_required_validations
                                  }}
                                </div>
                              }
                              @if (
                                exstingUserControls["mobileNo"].errors[
                                  "pattern"
                                ]
                              ) {
                                <div>
                                  {{
                                    prifileValidations.consumersPage.mobile
                                      .mobile_format
                                  }}
                                </div>
                              }
                              @if (
                                exstingUserControls["mobileNo"].errors[
                                  "maxlength"
                                ]
                              ) {
                                <div>{{ exstinguserValidationsMessage }}</div>
                                <!-- <div>{{prifileValidations.consumersPage.mobile_validation.mobile_mix_required_Validations}}</div> -->
                              }
                              @if (
                                exstingUserControls["mobileNo"].errors[
                                  "minlength"
                                ]
                              ) {
                                <div>{{ exstinguserValidationsMessage }}</div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-6 " *ngIf="isisdeviceIdExstingUser">
                        <div class="">
                          <label for="deviceId" class="form-label label-center">
                            Device ID <span class="required">*</span>
                          </label>
                          <ng-select
                            [items]="deviceIdList"
                            bindLabel="device_id"
                            bindValue="device_id"
                            formControlName="deviceId"
                            placeholder="Select country"
                            appendTo="body"
                            (change)="deviceIdchangesExstinguser($event)"
                          >
                            <ng-template ng-label-tmp let-item="item">
                              <span>{{ item.device_id }}</span>
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                              <span>{{ item.device_id }}</span>
                            </ng-template>
                          </ng-select>
                          @if (
                            (IsExstingUsersubmitted ||
                              exstingUserControls["deviceId"]?.touched) &&
                            exstingUserControls["deviceId"]?.errors
                          ) {
                            <div class="invalid-feedback d-block label-center">
                              @if (
                                exstingUserControls["deviceId"]?.errors?.[
                                  "required"
                                ]
                              ) {
                                <div>
                                  {{
                                    prifileValidations.gasLeakDetectoresePage
                                      .deviceId
                                  }}
                                </div>
                              }

                              <!--  @if(exstingUserControls['deviceId']?.errors?.['pattern']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId_pattern
                                                        }}
                                                    </div>
                                                    } -->

                              <!--  @if(exstingUserControls['deviceId']?.errors?.['maxlength'] ||
                                                    exstingUserControls['deviceId']?.errors?.['minlength']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.max }}</div>
                                                    } -->
                            </div>
                          }
                        </div>
                      </div>

                      <!--  <div class="col-md-6 ">
                                            <div class="">
                                                <label for="deviceId" class="form-label label-center">
                                                    Device ID <span class="required">*</span>
                                                </label>

                                                <div class="input-group">
                                                    <input type="text" formControlName="deviceId" class="form-control"
                                                        id="deviceId" placeholder="Enter Device ID" />

                                                    <button type="button" class="btn btn-primary"
                                                        [disabled]="isdeviceIdExstingUserValid"
                                                        (click)="isDeviceIdCheckExstingUser()">
                                                        Continue
                                                    </button>
                                                </div>

                                                @if((IsExstingUsersubmitted || exstingUserControls['deviceId']?.touched)
                                                &&
                                                exstingUserControls['deviceId']?.errors) {
                                                <div class="invalid-feedback d-block label-center">

                                                    @if(exstingUserControls['deviceId']?.errors?.['required']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId }}</div>
                                                    }

                                                    @if(exstingUserControls['deviceId']?.errors?.['pattern']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.deviceId_pattern
                                                        }}
                                                    </div>
                                                    }

                                                    @if(exstingUserControls['deviceId']?.errors?.['maxlength'] ||
                                                    exstingUserControls['deviceId']?.errors?.['minlength']) {
                                                    <div>{{ prifileValidations.gasLeakDetectoresePage.max }}</div>
                                                    }

                                                </div>
                                                }
                                            </div>
                                        </div> -->
                    </div>

                    <div class="row mb-3" *ngIf="isdeviceIdExstingUserValid">
                      <div class="col-md-6 ">
                        <div class="">
                          <label for="email" class="form-label label-center"
                            >Installed Location
                            <span class="required">*</span></label
                          >
                          <input
                            type="email"
                            formControlName="installedLocation"
                            class="form-control"
                            id="email"
                            placeholder="Enter your installed location"
                          />
                          @if (
                            IsExstingUsersubmitted &&
                            exstingUserControls["installedLocation"].errors
                          ) {
                            <div class="invalid-feedback label-center">
                              @if (
                                exstingUserControls["installedLocation"].errors[
                                  "required"
                                ]
                              ) {
                                <div>
                                  {{
                                    prifileValidations.gasLeakDetectoresePage
                                      .location
                                  }}
                                </div>
                              }
                              @if (
                                exstingUserControls["installedLocation"].errors[
                                  "pattern"
                                ]
                              ) {
                                <div>
                                  {{
                                    prifileValidations.gasLeakDetectoresePage
                                      .Installed_pattren
                                  }}
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </form>
                  <ul
                    class="list-inline wizard d-flex justify-content-end mt-3"
                  >
                    <!-- <li class="next list-inline-item"><button class="btn btn-primary"
                                            (click)="exstingUserCreate()">Create Device</button>
                                    </li> -->
                    <li
                      class="next list-inline-item"
                      *ngIf="isdeviceIdExstingUserValid"
                    >
                      <button
                        class="btn btn-primary"
                        (click)="MobileNoChekExstingUser()"
                      >
                        Create Device
                      </button>
                    </li>
                  </ul>
                </section>
              }
            </cdk-step>
          </ng-stepper>
        </div>
      </div>
    </div>
  </div>
</div>
